export default __webpack_public_path__ + "static/media/dayImg.4eba224d.svg";